import { render, staticRenderFns } from "./ThemeTable.vue?vue&type=template&id=2a1d1a56&scoped=true"
import script from "./ThemeTable.vue?vue&type=script&lang=js"
export * from "./ThemeTable.vue?vue&type=script&lang=js"
import style0 from "./ThemeTable.vue?vue&type=style&index=0&id=2a1d1a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d1a56",
  null
  
)

export default component.exports